"use strict";

var utils = {},
  debugError = require('debug')('algorithm:error');




utils.getMaximumPointerPrecision = function(config) {

  // check that we have correct field available in object
  if (config.decimals &&
    config.decimals.positions &&
    Array.isArray(config.decimals.positions) &&
    config.decimals.positions.length > 0 &&
    config.decimals.positions[config.decimals.positions.length - 1 ].precision) {
    return config.decimals.positions[config.decimals.positions.length - 1 ].precision;
  } else {
    debugError('config object does not have pointer precision');
    return 0.1;
  }

};


exports.getMaximumPointerIncrement = function(config) {
  var maximumIncrement = 0.7;

  // check if precision is fixed in configuration
  if (config.decimals &&
    config.decimals.maximumIncrement) {
    maximumIncrement = config.decimals.maximumIncrement;
  } else {
    switch (utils.getMaximumPointerPrecision(config)) {
      case 0.1:
        maximumIncrement = 0.7;
        break;
      case 0.01:
        maximumIncrement = 0.09;
        break;
      case 0.001:
        maximumIncrement = 0.009;
        break;
      default:
        maximumIncrement = 0.7;
        break;
      }
  }
  return maximumIncrement;
};

exports.adjustCoordinates = function(config) {
  if (!config.transformation) { config.transformation = {offset:{x:0, y:0}}}
  if (config.decimals && config.decimals.positions && Array.isArray(config.decimals.positions)) {
    for (var i = 0; i < config.decimals.positions.length; i++) {
      if (config.decimals.positions[i].coords) {
        config.decimals.positions[i].coords.x = parseInt(config.decimals.positions[i].coords.x, 10) + parseInt(config.transformation.offset.x, 10);
        config.decimals.positions[i].coords.y = parseInt(config.decimals.positions[i].coords.y, 10) + parseInt(config.transformation.offset.y, 10);
      }
    }
  }
  if (config.digits && config.digits.positions && Array.isArray(config.digits.positions)) {
    for (var j = 0; j < config.digits.positions.length; j++) {
      if (config.digits.positions[j].coords) {
        config.digits.positions[j].coords[0] = parseInt(config.digits.positions[j].coords[0], 10) + parseInt(config.transformation.offset.x, 10);
        config.digits.positions[j].coords[1] = parseInt(config.digits.positions[j].coords[1], 10) + parseInt(config.transformation.offset.y, 10);
        config.digits.positions[j].coords[2] = parseInt(config.digits.positions[j].coords[2], 10) + parseInt(config.transformation.offset.x, 10);
        config.digits.positions[j].coords[3] = parseInt(config.digits.positions[j].coords[3], 10) + parseInt(config.transformation.offset.y, 10);
      }
    }
  }
  return config;
}

function debugTiming(debugIdentifier, logger) {
  if (!logger) { logger = require('debug')}
  this.debug = logger(debugIdentifier);
  this.ts = new Date().getTime();
}
debugTiming.prototype.start = function () {
  this.ts = new Date().getTime();
}
debugTiming.prototype.log = function (string) {
  this.debug(string, new Date().getTime() - this.ts);
}
debugTiming.prototype.logAndReset = function (string) {
  this.log(string);
  this.start();
}



exports.debugTiming = debugTiming;





//////////////////
// WEBPACK FOOTER
// ./~/@smartvatten/flowone-algorithms/utils/index.js
// module id = 847
// module chunks = 0